import { apiURL } from "./constants";
import axios from "axios";

/**
 * TODO(permissions #59): No frontend helper yet for
 * /api/current_location/ (and /api/current_location/{id}/) — current_location_manage.
 * Permission: PERMISSIONS.CURRENT_LOCATION_MANAGE.
 * The endpoint is currently updated only as a side-effect of tracking-event
 * creation and the `current_location_text` field on Scan Shipment. If a
 * dedicated helper is added here, gate the caller via
 * <PermissionGate /> or hasPermission().
 * See ENDPOINTS_USAGE.md Phase 7.
 */


export async function getLocations(params = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/location/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

// eslint-disable-next-line no-unused-vars
export async function readLocations(searchTerm = '', _unusedParam = '') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const params = {
        page: 1,
        page_size: 30,
        pagination: true,
        ordering: 'name',
    };

    if (searchTerm) {
        params.search = searchTerm;
    }

    const response = await axios.get(`${apiURL}/api/location/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });

    return response;
}

export async function getLocation(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/location/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function createLocation(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(`${apiURL}/api/location/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response; 
}

export async function updateLocation(id, payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.put(`${apiURL}/api/location/${id}/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function deleteLocation(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.delete(`${apiURL}/api/location/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}
